const removeClass = (forceCloseOrEvent) =>
    forceCloseOrEvent.target
        ? undefined
        : forceCloseOrEvent === true
        ? false
        : undefined;

function toggleDesktopMenu1(forceClose) {
    document
        .querySelector(".nav_overlay")
        .classList.toggle("open", removeClass(forceClose));
}

function toggleDesktopMenu2(forceClose) {
    document
        .querySelector("body")
        .classList.toggle("menu_open", removeClass(forceClose));
}

function toggleMobileMenu(forceClose) {
    document
        .querySelector(".mobileMenu")
        .classList.toggle("menu-opened", removeClass(forceClose));
}

export default {
    init: () => {
        //Desktop burger
        document
            .querySelector(".open-menu")
            .addEventListener("click", toggleDesktopMenu1);

        let burgerToggle = document.querySelector(".burger-menu");

        burgerToggle.addEventListener("click", function (e) {
            e.preventDefault();
            burgerToggle.classList.toggle("menu-on");
        });

        document
            .querySelector(".open-menu2")
            .addEventListener("click", toggleDesktopMenu2);

        //Mobile menu SRC https://codepen.io/theaftermath87/pen/meZgzM

        document
            .querySelector(".burger-container")
            .addEventListener("click", toggleMobileMenu);
    },
    closeMenus: () => {
        toggleDesktopMenu1(true);
        toggleDesktopMenu2(true);
        toggleMobileMenu(true);
    }
};
